module.exports = __webpack_public_path__ + "img/jiashuhuijianshenhe.1ac468ed.png";